/* @flow */

import { isMembershipOptInCompleted } from '@e180/domain/lib/membership/util';

import { isMembershipTermsAccepted } from 'src/shared/domain/membership/util/membershipUtil';

import type { Membership } from '@e180/domain/lib/membership/type';

export function isOptinDone(
  membership: Membership,
  areEmailsNotificationsEnabled: boolean,
) {
  return !!(
    isNotificationOptinDone(membership, areEmailsNotificationsEnabled) &&
    isMembershipTermsAccepted(membership)
  );
}

export function isNotificationOptinDone(
  membership: Membership,
  areEmailsNotificationsEnabled: boolean,
) {
  return !!(
    !areEmailsNotificationsEnabled || isMembershipOptInCompleted(membership)
  );
}
